import { useMutation } from "@tanstack/react-query";
import { authApi } from "../api/authApi";

export function useVerifyEmailMutation() {
  return useMutation({ mutationFn: authApi.verifyEmail });
}
